import { z } from "zod";

/**
 * GET /auth/consent/status — the signed-in user's consent position against the
 * current Terms / Privacy versions. Shared FE ↔ Nest contract: the SPA parses
 * the response with `consentStatusSchema`; apps/api type-imports
 * `ConsentStatusDto` (it may not runtime-import @dallali/shared — see
 * tools/ci/check-api-shared-import.mjs).
 */
export const consentStatusSchema = z.object({
  /** At least one accepted Terms/Privacy record exists (any version). */
  hasConsent: z.boolean(),
  /** The current Terms or Privacy version has not been accepted. */
  needsReconfirm: z.boolean(),
  /** Latest marketing choice; false when never asked. */
  marketingOptIn: z.boolean(),
  /** The user has answered the marketing box at least once. */
  marketingAnswered: z.boolean(),
  /** The current Terms / Privacy versions the status was computed against. */
  versions: z.object({ terms: z.string(), privacy: z.string() }),
});

export type ConsentStatusDto = z.infer<typeof consentStatusSchema>;
